import { render, staticRenderFns } from "./parcel-book-success-modal.vue?vue&type=template&id=1f5819a9"
import script from "./parcel-book-success-modal.vue?vue&type=script&lang=js"
export * from "./parcel-book-success-modal.vue?vue&type=script&lang=js"
import style0 from "./parcel-book-success-modal.vue?vue&type=style&index=0&id=1f5819a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports